function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSezione05Popup04Ico03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 127.66 125.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.08,121.88v-6.96h41.79v9.29M56.86,114.92v-4.23c0-9.86-6.85-18.49-16.51-20.44-1.37-.28-2.85-.49-4.44-.64-2.18-.2-4.23-1.12-5.78-2.67l-10.09-10.09c-2.15-2.15-5.65-2.56-8-.64-2.7,2.21-2.85,6.2-.44,8.61l16.16,16.16M13.77,75.27l-2.77-16.42c-.32-2.46-2.42-4.3-4.9-4.3h0c-2.73,0-4.94,2.21-4.94,4.94v30.67c0,2.46.98,4.82,2.72,6.57l18.17,18.17M112.58,121.88v-6.96h-41.79v9.29M70.79,114.92v-4.23c0-9.86,6.85-18.49,16.51-20.44,1.37-.28,2.85-.49,4.44-.64,2.18-.2,4.23-1.12,5.78-2.67l10.09-10.09c2.15-2.15,5.65-2.56,8-.64,2.7,2.21,2.85,6.2.44,8.61l-16.16,16.16M113.89,75.27l2.77-16.42c.32-2.46,2.42-4.3,4.9-4.3h0c2.73,0,4.94,2.21,4.94,4.94v30.67c0,2.46-.98,4.82-2.72,6.57l-18.17,18.17",
    style: {
      fill: "none",
      stroke: "#e7b835",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.29,19.73c0,6.41-5.2,11.61-11.61,11.61s-11.61-5.19-11.61-11.61,5.2-11.61,11.61-11.61,11.61,5.19,11.61,11.61ZM52.22,38.31c0,6.41,5.2,11.61,11.61,11.61s11.61-5.19,11.61-11.61-5.2-11.61-11.61-11.61-11.61,5.19-11.61,11.61Z",
    style: {
      fill: "none",
      stroke: "#e7b835",
      strokeLinejoin: "round",
      strokeWidth: "2.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.08,68.49v13.93M47.58,68.49v13.93M89.37,77.77v-11.88c0-4-2.56-7.55-6.35-8.81l-7.58-2.53-11.61,11.61-11.61-11.61-7.58,2.53c-3.79,1.26-6.35,4.81-6.35,8.81v11.88",
    style: {
      fill: "none",
      stroke: "#e7b835",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.36,12.76c0,6.41,5.2,11.61,11.61,11.61s11.61-5.19,11.61-11.61S42.38,1.15,35.97,1.15s-11.61,5.19-11.61,11.61Z",
    style: {
      fill: "none",
      stroke: "#e7b835",
      strokeLinejoin: "round",
      strokeWidth: "2.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.94,40.63l-6.96,6.96-11.61-11.61-7.58,2.53c-3.38,1.13-5.76,4.07-6.25,7.52M117.12,46.03c-.48-3.45-2.87-6.39-6.25-7.52l-7.58-2.53-11.61,11.61-6.96-6.96M107.94,49.91v9.29M19.72,49.91v9.29",
    style: {
      fill: "none",
      stroke: "#e7b835",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.3px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSezione05Popup04Ico03);
export default __webpack_public_path__ + "static/media/sezione-05-popup-04-ico-03.27b459deec6285f4267ba209157870d2.svg";
export { ForwardRef as ReactComponent };